<div class="bodycontent">
  <div class="subheader with-padding flgrow">
    <div class="row">

      <!-- Dealer Dropdown -->
      <div class="col-6 col-lg-3">
        <div>
          <div class="relative flmid">
            <div class="flgrow">
              <ng-select class="" (change)="onChangeDealer($event)" [(ngModel)]="selectedDealers" name="dealerId"
                style="width: 100%" placeholder="{{ 'lblSelectDealer' | translate }}">
                <ng-option *ngFor="let dealer of dealerList" [value]="dealer.dealerId">
                  {{ dealer.dealerName }}
                </ng-option>
              </ng-select>
            </div>
          </div>
        </div>
        <p *ngIf="isDealerRequired" class="help-block text-danger" translate>lblRequiredDealer</p>
      </div>

      <!-- Date Range Picker -->
      <div class="col-lg-3 col-md-3 col-sm-6">
        <div class='date'>
        <input bsDaterangepicker name="BookedDate" [bsConfig]="myDateRangePickerOptions" class="form-control" 
        [(ngModel)]="selectedDate" (ngModelChange)="onDateRangeChanged($event)" required/>
        </div>
      </div>

      <!-- Search Button -->
      <div class="col-lg-2 col-md-3 col-sm-6">
        <div class="relative flmid">
          <button type="button" (click)="onSearch()" class="btn btn-primary">
            <em class="fa fa-search"></em>
          </button>
        </div>
      </div>

      <!-- Export Buttons -->
      <div class="pl-2  align-items-center flex-sm-row flex-column justify-content-end ml-auto">
        <!-- Excel -->
        <button type="button" (click)="exportAsXLSX()" ngbTooltip="{{'lblExportExcel' | translate}}" placement="bottom"
          aria-label="Center Align" style="margin-right: 10px;">
          <img src="./../../../assets/images/excel.png" height="32" width="32" alt="Excel" />
        </button>
        <!-- PDF -->
        <button class="btn btn-link icon-pdf" type="button" (click)="exportAsPDF()"
          ngbTooltip="{{'lblExportPDF' | translate}}" placement="bottom" aria-label="Center Align">
          <em class="far fa-file fa-2x"></em>
          <span class="bdg">PDF</span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Body -->
<div class="container prel">
  <div class="row">
    <div class="c12">
      <div class="card mb-3">
        <!-- Body Header -->
        <div class="card-header d-flex justify-content-between" translate>
          lblCDSSAgents
          <div class="font16 fontbold">
            <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;
            {{ totalCount }}
            &nbsp;<span class="font16 fontnormal" translate>lblResults</span>
          </div>
        </div>

        <!-- Body Content -->
        <div class="table-responsive max-h254" 
          >
          <table class="tablest1">
            <thead>
              <tr>
                <th style="width: 55px" scope="col">#</th>
                <th scope="col" style="width: 25%" translate>lblAgentName</th>
                <th scope="col" style="width: 20%"   class="text-right" translate> lblTotalCallDuration </th>
                <th scope="col" style="width: 20%"   class="text-right"  translate>  lblTotalCalls  </th>
                <th scope="col" style="width: 25%"  translate  class="text-right">lblCustomersInteracted</th>
                <th scope="col" style="width: 20%" class="text-right" translate>  lblAppointmentsCreatedModified  </th>
                <th scope="col" style="width: 20%" class="text-right" translate>  lblCustomersCreatedModified  </th>
                <th scope="col" style="width: 20%" class="text-right" translate> lblVehiclesCreatedModified  </th>
              </tr>
            </thead>

            <tbody>
              <ng-container *ngIf="dealerWiseAgentList?.length > 0; else load_NotFound_Template">
                <tr *ngFor="let item of dealerWiseAgentList; let i = index">
                  <td>{{ i + 1 }}</td>
                  <td>
                    <ngb-highlight [result]="item.agentName"> </ngb-highlight>
                  </td>
                  <td class="text-right link">
                    <ngb-highlight [result]="item.duration" ngbTooltip="View" tooltipClass="custom-revert"
                      (click)="onView(item,'Call')">
                    </ngb-highlight>
                  </td>
                  <td class="text-right">
                    <ngb-highlight [result]="item.totalCalls">
                    </ngb-highlight>
                  </td>
                  <td class="text-right">
                    <ngb-highlight [result]="item.customersInteracted"> </ngb-highlight>
                  </td>
                  <td class="text-right link">
                    <ngb-highlight [result]="item.appointments" ></ngb-highlight>
                      <!-- ngbTooltip="View" tooltipClass="custom-revert"  (click)="onView(item,'Appointment')" -->
                  </td>
                  <td class="text-right link">
                    <ngb-highlight [result]="item.customers" > </ngb-highlight>
                      <!-- ngbTooltip="View" tooltipClass="custom-revert" (click)="onView(item,'Customer')" -->
                  </td>
                  <td class="text-right link">
                    <ngb-highlight [result]="item.vehicles" >  </ngb-highlight>
                     <!-- ngbTooltip="View" tooltipClass="custom-revert"  (click)="onView(item,'Vehicle')" -->
                  </td>
                </tr>
              </ng-container>
              <ng-template #load_NotFound_Template>
                <tr>
                  <td colspan="8" class="no-record" translate>
                    lblNoRecordsFound
                  </td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>